import isDate from './isDate';
import isNumber from './isNumber';

function defaultParser(_) {
  return isNumber(_) ? _ : isDate(_) ? _ : Date.parse(_);
}

export default function(_, parser) {
  parser = parser || defaultParser;
  return _ == null || _ === '' ? null : parser(_);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-util/src/toDate.js
// module id = 558
// module chunks = 0